<template>
	<div
			v-if="searchResults || this.displayPage"
			ref="container"
			:class="{
        'mar-b': page.id.includes('adpage') && (this.flyerOrientation == 'vertical'),
        'bg-red': redPages.includes(page.id),
        'featured-page': page.isAdPage,
        'search-page': page.name === 'search_results' && this.flyerOrientation == 'horizontal',
        'search-page-vertical': page.name === 'search_results' && this.flyerOrientation == 'vertical',
        'no-gap': noGap && this.flyerOrientation == 'horizontal',
        'page-gap': !noGap && this.flyerOrientation == 'horizontal',
        'page-gap-vertical': this.flyerOrientation == 'vertical'
      }"
			:index="index"
			:page-id="page.id"
			:page-num="pageNum"
			:style="currentSectionStyle"
			class="section-container"
	>
		<!--    <block
				v-for="(b, index) in blocks"
				:key="page.id + '_block_' + index"
				:element="b"
				:device="device"
				:parent="page"
				:parent-col-count="colCount"
				:searchResults="searchResults"
				:unit-width="unitWidth"
				:unit-height=.unitHeight"
				:isAdPage="page.isAdPage"
				:root-scroll-container="rootScrollContainer"
			/>-->
		<flyer-block v-for="(b, index) in blocks" :key="page.id + '_block_' + index"
		             :block-data="b" :blockKey="generateBlockKey(page.id, index)"
		             :page="{ pageHeight, pageWidth, ...page, unitWidth, unitHeight }" :root-scroll-container="rootScrollContainer"/>
		<div v-if="page.name !== 'search_results'" :class="{ clickable: basebarLink }" :style="basebarStyle" class="basebar"
		     tabindex="0"
		     :role="basebarLink ? 'link' : null"
		     @click="handleBasebarClick"
		     @keydown.enter="handleBasebarClick"
		    >
			<template v-if="isXRayEnabled">
				<x-ray-click-regions
						:block-data="this.page.basebars"
						:block-rendered="renderedBasebarData"
						:flyer-data="pages"
						:flyer-rendered="flyerRenderedData"
						:page="page"
						:page-rendered="pageRenderedData"
						:pageData="this.page"/>
			</template>
			
			<img v-if="basebarImagePath" :alt="basebarAltText" :src="basebarImagePath" loading="lazy"/>
			<div v-if="basebarTextPath" class="cta-banner-wrapper">
				<img v-if="basebarObj.img" :src="basebarObj.img" alt="Canada's Garage" loading="lazy"/>
				<p :class="{'custom-margin': language === 'en'}" class="weather-basebar">{{ basebarTextPath }}
					<span class="desktop-only">|</span>
					<span v-observe-visibility="onVisibilityChange" :class="{ animate }" class="scale-box" @animationend="onAnimationEnd"><a :href="`https://www.canadiantire.ca/${language}/auto-appointment.html`" rel="noopener noreferrer"
					                                                                                                                         target="_blank" @click="handleAutoCentreClick">{{ this.basebarObj.link }}</a></span></p>
			</div>
			<!-- <div class="overlay"></div> -->
			<ExpandingDisclaimer v-if="this.page.disclaimer && this.displayMode === 'mobile'"
			                     :disclaimer="this.page.disclaimer"/>
			<p v-else-if="this.page.disclaimer">{{ this.page.disclaimer }}</p>

			<!-- <div class="basebar" :class="{ clickable: basebarLink }" :style="basebarStyle" @click="handleBasebarClick"> -->
		</div>
		<!-- <div >
		  <p>{{ zonedDisclaimer }} 123</p>
		</div> -->
	</div>
</template>
<script>
//import Block from "./block.component";
import {mapState, mapGetters, mapActions} from "vuex";
import {getClosestDPI} from "@/store/modules/scale";
import FlyerBlock from "@/components/block/FlyerBlock.vue";
import ExpandingDisclaimer from "@/components/ExpandingDisclaimer";
import Lytics from "@/classes/Lytics";
import XRayClickRegions from "@/features/x-ray/XRayClickRegions";
import ObjPropParser from "@/classes/ObjPropParser";
//import FlyerPage from "@/classes/FlyerPage";

let bbcount = 0;

export default {
	props: ["page", "page-num", "device", "index", "searchResults", "prevDocumentName", "rootScrollContainer"],
	components: {
		FlyerBlock,
		ExpandingDisclaimer,
		XRayClickRegions
	},
	mounted() {
		if (this.isXRayEnabled) {
			this.setPageRenderedData(this.renderedPageData);
		}
	},
	computed: {
		...mapState(["pages", "pageRenderedData", "flyerRenderedData"]),
		...mapGetters(["language", "isXRayEnabled", "lang"]),
		...mapState(["columnView", "zonesArray", "apiUrl"]),
		...mapGetters("screen", ["displayMode", "flyerOrientation"]),
		...mapGetters("scale", ["imageDPI"]),
		...mapGetters(['isRexall', 'isCTC']),
		...mapGetters('config', ['features', 'branding']),
		...mapGetters('search', {'searchConfig': 'config'}),
		basebarConfig() {
			return ObjPropParser.Parse(this.features?.basebar, this) || {};
		},

		renderedPageData() {
			return {
				unitWidth: this.unitWidth,
				unitHeight: this.unitHeight,
				displayPage: this.displayPage,
				grid: this.grid,
				colCount: this.colCount,
				rowCount: this.rowCount,
				pageHeight: this.pageHeight,
				pageWidth: this.pageWidth,
				pageStyles: this.currentSectionStyle
			};
		},
		renderedBasebarData() {
			return {
				basebarObj: this.basebarObj,
				basebarImagePath: this.basebarImagePath,
				basebarTextPath: this.basebarTextPath,
				basebarAltText: this.basebarAltText,
				basebarLink: this.basebarLink,
				basebarStyle: this.basebarStyle
			};
		},

		/**
		 *
		 * @returns number
		 */
		unitWidth() {
			if (this.grid["fitCols"]) {
				const fc = this.grid["fitCols"];
				const cols = this.colCount;
				return this.page.unitWidth * (fc / cols);
			}
			/* const fp = new FlyerPage(this.page);
			  return fp.getModeUnitWidth(this.virtualDisplayMode);*/
			return this.page.unitWidth;
		},

		/**
		 *
		 * @returns number
		 */
		unitHeight() {
			if (this.grid["fitCols"]) {
				const fc = this.grid["fitCols"];
				const cols = this.colCount;
				return this.page.unitHeight * (fc / cols);
			}
			/*const fp = new FlyerPage(this.page);
			return fp.getModeUnitHeight(this.virtualDisplayMode);*/
			return this.page.unitHeight;
		},

		displayPage() {
			return this.page.blocks.some(block => !block.placement || block.placement?.[this.displayMode].visible);
		},

		blocks() {
			const dm = this.flyerOrientation === "vertical" && this.displayMode === "desktop" ? "tablet" : this.displayMode;
			return this.page.blocks.filter(block => !block.placement || block.placement?.[dm].visible);
		},

		maxOrder() {
			const max = this.blocks.reduce((max, block) => {
				if (isNaN(max)) return 1000;
				return Math.max(max, block.placement?.[this.displayMode]?.order || 0);
			});
			return isNaN(max) ? 0 : max;
		},

		maxCoords() {
			const m = {
				rows: 0,
				cols: 0
			};

			this.blocks.forEach((item) => {
				const coords = item?.placement?.[this.displayMode]?.coordinates;
				if (coords) {
					const right = coords[2];
					const bottom = coords[3];
					m.rows = Math.max(bottom, m.rows);
					m.cols = Math.max(right, m.cols);
				}
			})

			return m;
		},

		pageDom() {
			return this.$refs.container;
		},

		showImages() {
			return true;
		},

		isAdPage() {
			return this.page.isAdPage;
		},

		grid() {
			return this.page.grids[this.virtualDisplayMode];
			/*		  if (this.flyerOrientation === 'vertical' && this.displayMode === 'desktop') {
					return this.page.grids['tablet'];
				  } else {
					return this.page.grids[this.device];
				  }*/
		},

		virtualDisplayMode() {
			if (this.flyerOrientation === "vertical" && this.displayMode !== "mobile") {
				return "tablet";
			}
			return this.displayMode;
		},

		colCount() {
			return this.grid.colCount;

			/*const fp = new FlyerPage(this.page);
			return fp.getModeCols(this.virtualDisplayMode);*/
			//if ((this.columnView || window.innerWidth < 800) && this.searchResults && this.device !== 'mobile') {
			/*if (this.flyerOrientation === 'vertical' && this.displayMode !== 'mobile') {
			  return fp.getModeCols('tablet'); //  this.page.grids['tablet'].colCount;
			} else {
			  return fp.getModeCols(this.displayMode); // this.page.grids[this.device].colCount;
			}*/
		},

		rowCount() {
			return this.grid.rowCount;
			/*const fp = new FlyerPage(this.page);
			return fp.getModeRows(this.virtualDisplayMode);*/
		},
		pageHeight() {
			return this.rowCount * this.unitHeight;
		},
		pageWidth() {
			return this.colCount * this.unitWidth;
		},
		grids() {
			return this.page.grids;
		},
		noGap() {
			return this.page?.noGapAfterPage;
		},
		currentSectionStyle: function () {

			const isVerticalSearch = this.page.name === 'search_results' && this.flyerOrientation === 'vertical' && this.device === 'desktop' && this.isCTC;
			if (this.searchConfig?.layout?.useCoords && this.page.name === 'search_results') {
				const coords = this.maxCoords;
				//const cols = '';
				return {
					...this.grid["style"],
					gridTemplateColumns: ` repeat(${coords.cols}, ${this.unitWidth}px)`,
					gridTemplateRows: ` repeat(${coords.rows}, ${this.unitHeight}px)`
				};
			}
			return {
				...this.grid["style"],
				gridTemplateColumns: isVerticalSearch
					? `repeat(6, ${this.unitWidth}px)`
					: `repeat(${this.colCount}, ${this.unitWidth}px)`,
				...this.gridRowTemplate
			};
		},
		gridRowTemplate: function () {
			/* if (this.flyerOrientation === 'horizontal') {
			   return {gridTemplateRows: `repeat(${this.rowCount},${this.unitHeight}px)`}
			 }*/
			return {gridTemplateRows: `repeat(${this.rowCount},${this.unitHeight}px)`};
		},
		basebarObj() {
			if (!this.page.basebars || this.page.name === "search_results") return null;
			let images = this.page.basebars[(this.basebarConfig?.displayModes?.[`${this.displayMode}-${this.flyerOrientation}`] || this.displayMode)] || this.page.basebars["desktop"]; //Missing tablet basebar object...
			//console.log('base bar: displayMode:', this.displayMode, '  images:', images)
			if (images.length) {
				images.sort((a, b) => {
					return a.resolution - b.resolution;
				});

				const highestRes = images.slice(-1).pop();

				//console.log('base bar: highestRes', highestRes);

				if (highestRes) return highestRes;
				else {
					const obj = getClosestDPI(this.imageDPI, images);
					return obj;
				}
				/*let obj = images.find((item) => {
				  // console.log("basebar resolution finding ", this.imageDPI)
				  return item.resolution == this.imageDPI;
				});

				if (!obj) {
				  obj = images.find(image => image.resolution > this.imageDPI);
				}*/


			}
			return null;
		},
		basebarImagePath() {
			if (this.basebarObj) {
				return this.basebarObj.image;
			}
			return null;
		},
		basebarTextPath() {
			if (this.basebarObj) {
				return this.basebarObj.text;
			}
			return null;
		},
		/**
		 * Alt text announced by screen readers for the basebar image.
		 * Reads `altText` from the feed, falling back to the localized
		 * default when the field is missing or empty.
		 *
		 * @returns string
		 */
		basebarAltText() {
			return this.readBasebarProp("altText") || this.lang?.basebar?.imageAlt || "";
		},
		basebarLink() {
			return this.basebarObj?.url || null;
		},
		basebarStyle() {
			const order = this.maxOrder;// this.blocks[this.blocks.length - 1]?.placement?.[this.displayMode]?.order + 1;
			return {
				gridColumn: `span ${this.grid.colCount}`,
				order: order,
				// display: `${this.page.basebars ? "block" : "none"}` //are we forcing basebars all the time ignoring json?
			};
		}
	},
	data() {
		return {
			animate: '',
			bbid: bbcount++,
			redPages: [
				"5f73e3bd87768b4b119a0d81",
				"5f73e54b87768b4b119a0f39"
			]
		};
	},
	methods: {
		...mapActions(["setPageRenderedData"]),

		hasBasebar: function () {
			return this.page.basebars[this.device].visible;
		},

		/**
		 * Reads a basebar property in the current language. Handles the shapes
		 * the feeds emit: a `{ en, fr }` object, `<prop>En` / `<prop>Fr`
		 * siblings, or a plain value when the feed is already served in the
		 * requested language.
		 *
		 * @param {string} prop
		 * @returns {string|undefined}
		 */
		readBasebarProp(prop) {
			const obj = this.basebarObj;
			if (!obj) return undefined;

			const value = obj[prop];
			if (value && typeof value === "object") {
				return value[this.language] ?? value.en;
			}

			return obj[`${prop}${this.language === "fr" ? "Fr" : "En"}`] ?? value;
		},

		handleBasebarClick() {
			if (this.basebarLink) {
				window.open(this.basebarLink);
				Lytics.TriggerLinkClick({url: this.basebarLink, page_number: this.page.page_num});
			}
		},
		handleAutoCentreClick() {
			Lytics.TriggerAutoCentreClick();
		},
		generateBlockKey(pageId, index) {
			return `${pageId}_block_${index}`;
		},
		triggerAnimation() {
			this.animate = false;
			requestAnimationFrame(() => {
				this.animate = true;
			})
		},
		onVisibilityChange(isVisible) {
			if (isVisible) {
				this.triggerAnimation();
			}
		},
		onAnimationEnd() {
			this.animate = false;
		}
	}
};
</script>

<style lang="scss">
@keyframes scaleOnce {
  0% {
	transform: scale(1)
  }
  50% {
	transform: scale(1.1)
  }
  100% {
	transform: scale(1)
  }
}

[mode='desktop'] [flyer-orientation='vertical'] [page-id='weatherPromos'].section-container {
  .cta-banner-wrapper {
	min-height: 32px;

	p {
	  font-size: 0.75em;
	}
  }
}

[mode='mobile'] [page-id='weatherPromos'].section-container {
  .basebar {
	.cta-banner-wrapper {
	  img {
		width: 42% !important;
	  }
	}
  }
}

.basebar {
  .cta-banner-wrapper {
	background: var(--secondary-color);
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	min-height: 28px;

	img {
	  width: 12.5% !important;
	  margin-right: auto;
	}

	p.weather-basebar {
	  color: #fff;
	  text-align: center;
	  font-size: 0.55em;
	  margin-right: 12%;

	  span.scale-box {
		display: inline-block;
		padding: 6px;
		transition: transform 0.2s;

		&:hover {
		  animation: scaleOnce 1.2s ease forwards;
		}

		a {
		  color: #fff;
		  margin-top: 2px;
		  margin-left: 6px;
		  font-size: 1.3em;
		  text-decoration: none;
		  text-transform: uppercase;
		}
	  }

	  span.scale-box.animate {
		animation: scaleOnce 1.2s ease forwards 2;
	  }
	}

	p.weather-basebar.custom-margin {
	  margin-right: 18%;
	}
  }
}
</style>

<style scoped>

.section-container.featured-page {
	display: block;
	height: 100%;
	margin-bottom: 10px;
}

.section-container.featured-page > .block {
	grid-area: unset !important;
	display: block;
	/* height: 100%; */
}

.section-container.featured-page > .block > .image {
	width: auto !important;
	height: available !important;

}

.section-container {
	display: grid;
	grid-auto-flow: dense;

}

.section-container.search-page {
	grid-auto-flow: column dense;
}

.section-container.search-page-vertical {
	/* grid-auto-flow: column dense; */
	/*grid-template-columns: repeat(4, 287px) !important;*/
	/* /*Commented since it creates a gap btwn block in category search in vertical mode.*/
}


.section-container.bg-red {
	background-color: #ED1C24;
}

.section-container.bg-red .basebar {
	background-color: #FFF;
	margin: 0 -1px;
	width: calc(100% + 2px);
	height: calc(100% + 2px);
}

.section-container.no-gap {
	margin-right: 0px;
}

.section-container.page-gap {
	margin-right: 20px;
}

.section-container.page-gap-vertical {
	margin-bottom: 10px;
}

.basebar {
	width: 100%;
	order: 999;
	padding-top: 5px;
	display: block;
}

.basebar img {
	width: 100%;
}

.basebar p {
	font-size: 6px;
	text-align: center;
	padding: 0 5px;
	line-height: 1.2;
}

.basebar.clickable {
	cursor: pointer;
}

.basebar:focus-visible {
	outline: 2px solid #0067b4;
	outline-offset: -2px;
}

[mode='tablet'] .basebar,
[mode='mobile'] .basebar,
.column-view .basebar {
	padding-bottom: 5px;
}

.section-container.mar-b {
	margin-bottom: 10px;
}

.overlay {
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	position: absolute;
}

.basebar {

	position: relative;
}
</style>
